var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.wrapClasses,on:{"click":_vm._toggle}},[_c('span',{class:_vm.prefix + '-inner'},[(_vm.checkStatus)?_vm._t("checkedChildren"):_vm._e(),_vm._v(" "),(!_vm.checkStatus)?_vm._t("unCheckedChildren"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2159dfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/switch/switch.vue
// module id = null
// module chunks = 